export class dropdownMenuInfo {
  text: string;
  path?: string;
  disabled?: boolean;
  indent?: boolean;
}

